module.exports = "/images/new-job-background.png?e783e63de72a5aa3ad4b6b83687ebd1f";